import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rawMaterials: [],
  rawMaterialsPagination: null,
  isLoading: false,
};

const RawMatarialSlice = createSlice({
  name: "RawMatarial",
  initialState,
  reducers: {
    setRawMaterials(state, action) {
      state.rawMaterials = action.payload.data || action.payload;
      state.rawMaterialsPagination = action.payload.pagination || null;
      state.isLoading = false;
    },
    setRawMaterialsLoading(state, action) {
      state.isLoading = action.payload;
    },
    updateRawMaterial(state, action) {
      const { index, rawMaterial } = action.payload;
      state.rawMaterials.splice(index, 1, rawMaterial);
    },
    deleteRawMaterial(state, action) {
      const { index } = action.payload;
      state.rawMaterials.splice(index, 1);
    },
  },
});

export const {
  setRawMaterials,
  setRawMaterialsLoading,
  updateRawMaterial,
  deleteRawMaterial,
} = RawMatarialSlice.actions;

export default RawMatarialSlice.reducer;